module.exports = __webpack_public_path__ + "img/i_nav_find_new_on.67197425.svg";